/**
 *
 *
 */

( function () {
    'use strict';

    window.ImageOverlay = ImageOverlay;

    function ImageOverlay(imageSelector) {
        this._imageSelector = imageSelector;
        this._TIMEOUT_IMAGE_LOAD = 60000; //60секунд
        this._timeoutImageLoadId = null;

        this._overlay = document.querySelector('.js-image-overlay');
        this._preview = this._overlay.querySelector('.js-preview');
        this._img = this._overlay.querySelector('.js-img');
        this._btnClose = this._overlay.querySelector('.js-btn-close');
    }

    ImageOverlay.prototype.init = function () {
        this._bindHandlers();

        return this;
    };

    ImageOverlay.prototype.show = function (imageUrl) {
        this._loadImage(imageUrl, (loaded) => {
            if (loaded) {
                this._setSizePreview(this._img);
            }

            this._show(imageUrl);
        });
    };

    ImageOverlay.prototype._setSizePreview = function (img) {
        let maxSize = this._getMaxSize();
        let percent;
        let width = maxSize.width;
        let height = maxSize.height;

        if (img) {
            if (img.naturalWidth > maxSize.width) {
                width = maxSize.width;

                percent = ((width * 100) / img.naturalWidth);
                height = Math.ceil((percent * img.naturalHeight) / 100);
            } else if (img.naturalHeight > maxSize.height) {
                height = maxSize.height;

                percent = (height * 100) / img.naturalHeight;
                width = Math.ceil((percent * img.naturalWidth) / 100);
            } else {
                width = img.naturalWidth;
                height = img.naturalHeight;
            }
        }

        this._preview.style.width = width + 'px';
        this._preview.style.height = height + 'px';
    };

    ImageOverlay.prototype._show = function (imageUrl) {
        if (!imageUrl) {
            return;
        }

        if (this._img.src !== imageUrl) {
            this._img.src = imageUrl;
        }

        this._overlay.classList.add('is-show');
    };

    ImageOverlay.prototype._hide = function () {
        this._overlay.classList.remove('is-show');
        this._img.src = '';
        this._imageFinish();
    };

    ImageOverlay.prototype._isImage = function (el) {
        if (!this._imageSelector) {
            return false;
        }

        return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, this._imageSelector);
    };

    ImageOverlay.prototype._getMaxSize = function () {
        return {
            width: parseInt(window.innerWidth, 10) * 0.9, //90% от ширины,
            height: parseInt(window.innerHeight, 10) * 0.9 //90% от высоты
        }
    };

    ImageOverlay.prototype._loadImage = function (url, callback) {
        if (!url) {
            return;
        }

        this._img.onload = () => {
            this._imageFinish();

            callback(true);

        };
        this._img.onerror = () => {
            this._imageFinish();

            callback(false);
        };

        this._timeoutImageLoadId = setTimeout(() => {
            this._imageFinish();
            callback(false);
        }, this._TIMEOUT_IMAGE_LOAD);

        this._img.src = url;
    };

    ImageOverlay.prototype._imageFinish = function () {
        clearTimeout(this._timeoutImageLoadId);
        this._img.onload = null;
        this._img.onerror = null;
    };

    ImageOverlay.prototype._bindHandlers = function () {
        this._onClick = this._onClick.bind(this);
        document.addEventListener('click', this._onClick);

        this._onBtnCloseClick = this._onBtnCloseClick.bind(this);
        this._btnClose.addEventListener('click', this._onBtnCloseClick);

        this._onOverlayClick = this._onOverlayClick.bind(this);
        this._overlay.addEventListener('click', this._onOverlayClick);

        this._onKeyDown = this._onKeyDown.bind(this);
        window.addEventListener('keydown', this._onKeyDown);
    };

    ImageOverlay.prototype._onClick = function (evt) {
        if (!this._isImage(evt.target)) {
            return;
        }

        this._setSizePreview(evt.target);

        this._show(evt.target.src);
    };

    ImageOverlay.prototype._onBtnCloseClick = function () {
        this._hide();
    };

    ImageOverlay.prototype._onOverlayClick = function (evt) {
        if (!evt.target.classList.contains('js-image-overlay')) {
            return;
        }

        this._hide();
    };

    /**
     * Обработчик события: нажатие клавиши
     *
     */
    ImageOverlay.prototype._onKeyDown = function (e) {
        if (e.keyCode === 27) {
            this._hide();
        }
    }

}());

